const {
  interceptNativeSubmit,
  subscribeToNewsletter,
  wasFormPosted,
} = window.BAO.Utils

class MobileMenuNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form', 'email', 'error', 'success']
  }

  constructor () {
    super()

    this.signupSource = 'website_mobile_menu'
  }

  connectedCallback () {
    super.connectedCallback()

    // Back from a native or `/challenge` submission that Shopify accepted.
    if (wasFormPosted(this.els.form.element)) {
      this.revealPostedSuccess()
    }
  }

  // The form sits in a closed accordion in the closed menu, so open both and scroll to it.
  async revealPostedSuccess () {
    this.showSuccess()

    await Promise.all(
      ['site-drawers', 'site-drawer', 'accordion-group'].map(name =>
        customElements.whenDefined(name),
      ),
    )

    this.externalEls['menu-trigger']?.element?.click()

    const accordionTrigger = this.externalEls['accordion-trigger']?.element
    if (accordionTrigger?.getAttribute('aria-expanded') !== 'true') {
      accordionTrigger?.click()
    }

    window.requestAnimationFrame(() => this.scrollIntoView({ block: 'center' }))
  }

  setupListeners () {
    super.setupListeners()

    this.submitForm = interceptNativeSubmit(
      this.els.form.element,
      () =>
        this.createClientSubscription({
          emailAddress: this.els.email.element.value.replace(/\s/g, ''),
        }),
      { source: this.signupSource },
    )

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onFormSubmit.bind(this),
    )

    this.listeners.add(
      this.els.email.element,
      'input',
      this.handleEmailInput.bind(this),
    )
  }

  handleEmailInput () {
    if (this.validEmail()) {
      this.els.email.element.setAttribute('aria-invalid', false)
    } else {
      this.els.email.element.setAttribute('aria-invalid', true)
    }
  }

  async onFormSubmit (e) {
    e.preventDefault()

    // Only show the outcome of the latest submission.
    this.toggleErrorMessage()
    this.els.success.element.setAttribute('aria-hidden', true)

    if (!this.validEmail()) {
      // Stop Shopify's own submit listeners from sending an invalid form.
      e.stopImmediatePropagation()
      this.els.email.element.setAttribute('aria-invalid', true)
      this.els.email.element.focus()
      return
    }

    // To-do: Run Ometria account lookup

    this.submitForm()
  }

  async createClientSubscription (formData) {
    const { emailAddress } = formData

    const subscribed = await subscribeToNewsletter(emailAddress, {
      source: this.signupSource,
      form: this.els.form.element,
    })

    if (!subscribed) {
      this.toggleErrorMessage(window.theme.strings.newsletterGenericError)
      return
    }

    this.toggleErrorMessage()
    this.showSuccess()
  }

  toggleErrorMessage (message = false) {
    const errorElement = this.els.error.element
    if (!message) {
      errorElement.setAttribute('aria-hidden', true)
    } else {
      errorElement.setAttribute('aria-hidden', false)
      errorElement.innerHTML = message
    }
  }

  async showSuccess () {
    const success = this.els?.success?.element

    if (success) success.removeAttribute('aria-hidden')
  }

  validEmail () {
    const emailAddress = this?.els?.email?.element?.value.replace(/\s/g, '')

    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return emailRegex.test(emailAddress)
  }
}

if (!customElements.get('mobile-menu-newsletter')) {
  customElements.define('mobile-menu-newsletter', MobileMenuNewsletter)
}
